module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.4.1@core-js/library/modules/_html.js
// module id = 78
// module chunks = 20